import React, { useState } from "react";
import { db } from "../firebaseConfig";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";

const Booking = ({ lang }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    service: "",
    date: "",
    time: "",
  });

  const content = {
    ar: {
      subTitle: "ابدأ رحلتك القانونية",
      title: "حجز موعد استشارة",
      desc: "نقدّر وقتك، ولذلك وفرنا لك نظام حجز مسبق لضمان حصولك على الاهتمام الكامل من مستشارينا المختصين.",
      benefitsTitle: "ماذا تتوقع؟",
      benefits: ["تحليل قانوني دقيق لموقفك الحالي.", "خطة عمل واضحة وتوصيات استراتيجية.", "سرية تامة لجميع المعلومات والبيانات.", " تقدير مبدئي للأتعاب والفترة الزمنية المتوقعة."],
      form: {
        name: "الاسم",
        phone: "الهاتف",
        serviceLabel: "نوع الاستشارة",
        btn: "تأكيد الحجز",
        success: "تم الإرسال!",
      },
    },
    en: {
      subTitle: "Start Journey",
      title: "Book Consultation",
      desc: "We value your time. Our booking system ensures you receive dedicated attention from our specialized consultants.",
      benefitsTitle: "What to expect?",
      benefits: [
        "Accurate legal analysis of your situation.",
        "Clear action plan and strategic recommendations.",
        "Complete confidentiality of all information.",
        "Initial estimation of fees and timeline.",
      ],
      form: {
        name: "Name",
        phone: "Phone",
        serviceLabel: "Service Type",
        btn: "Confirm",
        success: "Sent!",
      },
    },
  };
  const t = content[lang];
  const isAr = lang === "ar";

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      await addDoc(collection(db, "bookings"), {
        ...formData,
        status: "جديد",
        createdAt: serverTimestamp(),
        lang,
      });
      alert(t.form.success);
      setFormData({ name: "", phone: "", service: "", date: "", time: "" });
    } catch (error) {
      alert("Error submitting request");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section
      className="booking-section"
      id="booking"
      dir={isAr ? "rtl" : "ltr"}
    >
      <div className="container">
        <div className="booking-wrapper">
          {/* الجانب المعلوماتي */}
          <div className="booking-info-side">
            <h4 className="booking-subtitle">{t.subTitle}</h4>
            <h2 className="booking-title">{t.title}</h2>
            <div className="gold-line-left"></div>
            <p className="booking-desc">{t.desc}</p>
            <h3 className="benefits-title">{t.benefitsTitle}</h3>
            <ul className="benefits-list">
              {t.benefits.map((b, i) => (
                <li key={i} className="benefit-item">
                  <span className="check-icon">✓</span> {b}
                </li>
              ))}
            </ul>
          </div>

          {/* الفورم */}
          <div className="booking-form-side">
            <form className="booking-form" onSubmit={handleSubmit}>
              <div className="form-row">
                <div className="form-group">
                  <label>{t.form.name}</label>
                  <input
                    type="text"
                    name="name"
                    className="booking-input"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label>{t.form.phone}</label>
                  <input
                    type="tel"
                    name="phone"
                    className="booking-input"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              <div className="form-group">
                <label>{t.form.serviceLabel}</label>
                <select
                  name="service"
                  className="booking-input select-input"
                  value={formData.service}
                  onChange={handleChange}
                  required
                >
                  <option value="">-- {t.form.serviceLabel} --</option>
                  <option value="شركات">شركات</option>
                  <option value="قضايا">قضايا</option>
                  <option value="أخرى">أخرى</option>
                </select>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>التاريخ</label>
                  <input
                    type="date"
                    name="date"
                    className="booking-input"
                    value={formData.date}
                    onChange={handleChange}
                  />
                </div>
                <div className="form-group">
                  <label>الوقت</label>
                  <input
                    type="time"
                    name="time"
                    className="booking-input"
                    value={formData.time}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <button
                type="submit"
                className="booking-btn"
                disabled={isSubmitting}
                style={{ opacity: isSubmitting ? 0.7 : 1 }}
              >
                {isSubmitting ? "..." : t.form.btn}
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Booking;
